import { render, staticRenderFns } from "./userHistory[date_time].vue?vue&type=template&id=38cfffcb&"
import script from "./userHistory[date_time].vue?vue&type=script&lang=js&"
export * from "./userHistory[date_time].vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports